import { type TextType } from "@vibe/typography";
import { type LabelSizes } from "./Label.types";

export const mapSizesToTextSize: Record<LabelSizes, TextType> = {
  small: "text3",
  medium: "text2"
};
